export const LICIT_ESP_ID = "licitacao_especifica_id";

export const setLicitacaoId = id => {
  localStorage.setItem(LICIT_ESP_ID, id);
};
export const getLicitacaoId = () => localStorage.getItem(LICIT_ESP_ID);
